import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { apiResponse, apiError } from '../schemas/common.schema';

const c = initContract();
const LoginResponseSchema = z.object({ accessToken: z.string() });

export const authContract = c.router({
  login: {
    method: 'POST',
    path: '/auth/login',
    body: z.object({ emailOrPhone: z.string(), password: z.string() }),
    responses: { 200: apiResponse(LoginResponseSchema) },
  },
  getProfile: {
    method: 'GET',
    path: '/auth/profile',
    responses: { 200: apiResponse(z.any()), 401: apiError },
  },
  loginByOAuthGmail: {
    method: 'POST',
    path: '/auth/oauth/gmail',
    body: z.object({ code: z.string(), redirect_uri: z.string() }),
    responses: { 200: apiResponse(LoginResponseSchema) },
  },
  recoverPassword: {
    method: 'POST',
    path: '/auth/password/recover',
    body: z.object({ emailOrPhone: z.string() }),
    responses: {
      200: apiResponse(z.object({ contact: z.object({ contact_fullname: z.string().optional() }) })),
    },
  },
});
